import { styled } from "styled-components";

// 리뷰 이미지
export const ReviewImage = styled.img`
  width: 200px;
  height: 164px;
  margin-left: 50px;
  margin-bottom: 20px;
`;
